import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { PlayIcon, CheckCircleIcon, LockIcon, ClockIcon } from 'lucide-react';
interface Lesson {
  id: number;
  title: {
    en: string;
    ar: string;
  };
  description: {
    en: string;
    ar: string;
  };
  duration: string;
  durationAr: string;
  isCompleted: boolean;
  isLocked?: boolean;
}
interface LessonCardProps {
  lesson: Lesson;
  onLessonClick: (lessonId: number) => void;
}
export function LessonCard({
  lesson,
  onLessonClick
}: LessonCardProps) {
  const {
    isArabic
  } = useLanguage();
  return <div className={`
        p-4 rounded-lg border transition-colors
        ${lesson.isLocked ? 'border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 cursor-not-allowed' : lesson.isCompleted ? 'border-green-200 dark:border-green-800 bg-green-50 dark:bg-green-900/10 hover:bg-green-100 dark:hover:bg-green-900/20 cursor-pointer' : 'border-blue-200 dark:border-blue-800 bg-white dark:bg-gray-800 hover:bg-blue-50 dark:hover:bg-blue-900/10 cursor-pointer'}
      `} onClick={() => !lesson.isLocked && onLessonClick(lesson.id)} data-id="element-868">
      <div className="flex items-center justify-between" data-id="element-869">
        <div className="flex items-center gap-3" data-id="element-870">
          <div className={`
              p-2 rounded-lg
              ${lesson.isLocked ? 'bg-gray-200 dark:bg-gray-700' : lesson.isCompleted ? 'bg-green-100 dark:bg-green-900/30' : 'bg-blue-100 dark:bg-blue-900/30'}
            `} data-id="element-871">
            {lesson.isLocked ? <LockIcon className="w-5 h-5 text-gray-500 dark:text-gray-400" data-id="element-872" /> : lesson.isCompleted ? <CheckCircleIcon className="w-5 h-5 text-green-600 dark:text-green-400" data-id="element-873" /> : <PlayIcon className="w-5 h-5 text-blue-600 dark:text-blue-400" data-id="element-874" />}
          </div>
          <div data-id="element-875">
            <h3 className={`font-medium ${lesson.isLocked ? 'text-gray-500 dark:text-gray-400' : 'text-gray-900 dark:text-white'}`} data-id="element-876">
              {isArabic ? lesson.title.ar : lesson.title.en}
            </h3>
            <p className={`text-sm ${lesson.isLocked ? 'text-gray-400 dark:text-gray-500' : 'text-gray-600 dark:text-gray-300'}`} data-id="element-877">
              {isArabic ? lesson.description.ar : lesson.description.en}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400" data-id="element-878">
          <ClockIcon className="w-4 h-4" data-id="element-879" />
          <span data-id="element-880">{isArabic ? lesson.durationAr : lesson.duration}</span>
        </div>
      </div>
    </div>;
}